import React, { useState, useEffect } from 'react';
import { formatDate } from 'react-day-picker/moment';
import { DateTime } from 'luxon';
import _ from 'lodash';

import Label from '../../../components/label';
import InputNumeral from '../../../components/input-numeral';
import TextNumber from '../../../components/text-number';
import ReportButton from '../../../components/report-button';
import DayPicker from '../../../components/day-picker';
import Select from '../../../components/select';
import LoaderType from '../../../components/loader-type';
import { getData, getFile } from '../../../helper/request-response';
import { downloadFile } from '../../../helper/util';
import constant from '../../../config/constant';
import retrPath from './config';

const List = () => {

    const [isLoad, setIsLoad] = useState(true);

    const [startDate, setStartDate] = useState(DateTime.local());

    const [endDate, setEndDate] = useState(DateTime.local());

    const [selectedTrack, setSelectedTrack] = useState(constant.DEFAULT_SELECTED);

    const [retributionId, setRetributionId] = useState();

    const [retribution, setRetribution] = useState([]);

    const [retributionSummary, setRetributionSummary] = useState({
        invoices: 0,
        farmer: 0,
        agent: 0,
        qty: 0,
        amount: 0 
    });

    const onStartDateChange = day => {

        setStartDate(formatDate(day, constant.DEFAULT_DATE));
        setEndDate(formatDate(day, constant.DEFAULT_DATE));
    };

    const onEndDateChange = day => setEndDate(formatDate(day, constant.DEFAULT_DATE));

    const getRetributions = () => {

        setIsLoad(true);

        const params = getParams();

        getData(retrPath.base, params).then(result => setRetribution(result[0]));

        getData(retrPath.palmOilRetrSum, params).then(result => {

            if (!_.isEmpty(result[0])) {

                setRetributionSummary(sum => ({
                    ...sum,
                    invoices: result[0][0].purchaseInvNoCnt,
                    farmer: result[0][0].farmerCount,
                    agent: result[0][0].agentCount,
                    qty: result[0][0].retrQty,
                    amount: result[0][0].retr,
                }));
            }

            setIsLoad(false);

        });

    }

    const getParams = () => {

        const params = {
            params: { 
                'start-date': DateTime.fromISO(startDate).toFormat(constant.PARAM_DATE_FORMAT),
                'end-date': DateTime.fromISO(endDate).toFormat(constant.PARAM_DATE_FORMAT),
                'retribution-id': retributionId
            }
        };

        return params;
    }

    const onNameChange = opt => {

        if (opt.id) {
            
            setSelectedTrack(name => ({
                ...name,
                value: opt.id,
                label: opt.label
            }));

            setRetributionId(opt.id);

        }

    }
    
    const onExport = e => {

        e.preventDefault();

        const params = getParams();

        getFile(retrPath.palmOilRetrExcel, params).then(response => downloadFile(response));

    }

    const onSubmit = e => {

        e.preventDefault();

        getRetributions();


    }

    const onReset = e => {

        e.preventDefault();

        setStartDate(DateTime.local());

        setSelectedTrack(constant.DEFAULT_SELECTED);

        getRetributions();

    }

    useEffect(getRetributions, []);

    return(
        <React.Fragment>
            <div className="card-header">
                <h3 className="h6 text-uppercase mb-0">{ retrPath.title }</h3>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-6 border-right">
                        <form className="form-horizontal" onSubmit={ e => onSubmit(e) }>
                            
                            <div className="form-group row">
                                <div className="col-md-6">
                                    <Label htmlFor="start-date" text="Tanggal Dari" />
                                    <DayPicker id="start-date" name="start-date" onDayChange={onStartDateChange} valueDate={ startDate } />
                                </div>
                                <div className="col-md-6">
                                    <Label htmlFor="end-date" text="Tanggal Ke" />
                                    <DayPicker id="end-date" name="end-date" onDayChange={onEndDateChange} valueDate={ endDate } />
                                </div>
                            </div>

                            <div className="form-group row">
                                
                                <div className="col-md-12">
                                    <Label htmlFor="retri-name" text="Jalur Retribusi" />
                                    <Select
                                        id="retri-name"
                                        paramFilter="name"
                                        api={ retrPath.palmOilRetrFind }
                                        onChange={ onNameChange }
                                        value={ selectedTrack }
                                    />
                                </div>
                            </div>

                            <div className="form-group row">
                                <div className="col-md-12">
                                    <ReportButton isSubmit={ true } onClick={ onReset } onExport={ onExport }/>
                                </div>
                            </div>
                        </form>
                    </div>

                    {
                        !isLoad &&
                        <div className="col-md-6">
                            <div className="form-group row">
                                <div className="col-md-12">
                                    <h3>Rekapitulasi</h3>
                                </div>
                            </div>

                            <div className="form-group row">
                                <div className="col-md-6">
                                    <Label text="Jumlah Petani" />
                                    <InputNumeral
                                        value={ retributionSummary.farmer }
                                        display={ true }
                                    />
                                </div>

                                <div className="col-md-6">
                                    <Label text="Jumlah Agen" />
                                    <InputNumeral
                                        value={ retributionSummary.agent }
                                        display={ true }
                                    />
                                </div>
                            </div>

                            <div className="form-group row">
                                <div className="col-md-12">
                                    <Label text="Total Kilogram (Kg)" />
                                    <InputNumeral
                                        value={ retributionSummary.qty }
                                        display={ true }
                                    />
                                </div>
                            </div>

                            <div className="form-group row">
                                <div className="col-md-12">
                                    <Label text="Total Pembelian (Rp)" />
                                    <InputNumeral
                                        value={ retributionSummary.amount }
                                        display={ true }
                                    />
                                </div>
                            </div>
                        </div>
                    }
                </div>

                {
                    isLoad &&
                    <LoaderType />
                }

                {
                    !isLoad && retribution.length > 0 &&
                    <>
                        <br />

                        <div className="row">
                            <div className="col-lg-12">
                                <div className="table-responsive">
                                    <table className="table table-striped table-hover card-text">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Tanggal</th>
                                                <th>Faktur Penjualan</th>
                                                <th>Faktur Pembelian</th>
                                                <th>Nama Pelanggan</th>
                                                <th>Tipe Pelanggan</th>
                                                <th>Jalur</th>
                                                <th>Jumlah (Kg)</th>
                                                <th>Harga (Rp)</th>
                                                <th>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                retribution.map((co, index) => {
                                                    return(
                                                        <tr key={ index }>
                                                            <th scope="row">{ index + 1 }</th>
                                                            <td>{ formatDate(co.trxDate, 'DD MMM YY', constant.LOCALE) }</td>
                                                            <td>{ co.sellingInvNo }</td>
                                                            <td>{ co.purchaseInvNo }</td>
                                                            <td>{ co.customerName }</td>
                                                            <td>{ co.customerType }</td>
                                                            <td>{ co.retrName }</td>
                                                            <td><TextNumber value={ co.retrQty } /></td>
                                                            <td><TextNumber value={ co.retrRate } /></td>
                                                            <td><TextNumber value={ co.retr } /></td>
                                                            <td></td>
                                                        </tr>
                                                    );
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </>
                }
            </div>
        </React.Fragment>
    );
};

export default List;
